import { ga } from 'js/analytics/adapters'

export const trackViewFaq = () => {
  ga.track('view_faq')
}
